import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n'
import Checkbox from '../../UI/Checkbox/Checkbox';
import ErrorBox from '../../UI/ErrorBox/ErrorBox';
import ReactHtmlParser from 'html-react-parser';
export function AutorenewalTerms(props, errorStates) {
    const { t, i18n } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);

  

    // Default to true when the prop is not supplied so existing behaviour (checkbox shown) is preserved.
    const showConsentCheckbox = props.showConsentCheckbox !== false;

    useEffect(() => {

        // When the consent checkbox is hidden via config, treat consent as implicitly given and clear
        // any pending validation error so submission is never blocked.
        if (!showConsentCheckbox) {
            props.setIsAutoRenewalChecked(true);
            props.setErrorStates(errorStates => ({ ...errorStates, autoRenewalNotTicked: false }));
            return;
        }

        props.setIsAutoRenewalChecked(isChecked);
        if (isChecked) {
            props.setErrorStates(errorStates => ({ ...errorStates, autoRenewalNotTicked: false }))
        }

    }, [isChecked, showConsentCheckbox])

    return (
        <div className="item-container">
            <label className="label">{t('autorenewalterms.title')}</label>
                <div className="item-wrapper">
                {props?.renewalText && <p>{ReactHtmlParser(props?.renewalText)}</p>}
                {showConsentCheckbox &&
                    <>
                    <Checkbox label={t('autorenewalterms.consentcheckboxlabel')} checked={isChecked} onChange={() => { setIsChecked(!isChecked) }} id="autorenewalconsent" name="autorenewalconsent" />
                    {props.errorStates.autoRenewalNotTicked ?
                        <span role="alert" id='payment-not-selected'><ErrorBox>{t('payment.autorenewalcheckboxnotticked')}</ErrorBox></span>
                        : ""}
                    </>
                }
                </div>
            </div>
    );
}

